import React from 'react';
import PropTypes from 'prop-types';
import logo from 'assets/images/plus-logo.svg';

const Welcome = ({ children }) => (
  <div className="welcome-screen">
    <div className="welcome-screen__header">
      <img className="welcome-screen__logo" src={logo} role="presentation" />
    </div>
    <div className="welcome-screen__content">{children}</div>
  </div>
);

Welcome.propTypes = {
  children: PropTypes.node.isRequired
};

export default Welcome;
